var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"flat":""}},[_c('data-page',_vm._b({},'data-page',_vm.dataBind,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }